module.exports = __webpack_public_path__ + "img/Home_Desktop_04.8a1b2da5.jpg";